import { Button } from "@mui/material";
import React, { FC, useState } from "react";
import { IoCheckmarkCircleOutline } from "react-icons/io5";

import { SaveViewModal } from "./SaveViewModal";

export const SaveViewActionModal: FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        variant="text"
        startIcon={<IoCheckmarkCircleOutline />}
        onClick={() => setIsOpen(true)}
        sx={(theme) => ({
          color: theme.palette.custom?.safeGreen ?? "#5AB34B",
          minWidth: "auto",
          whiteSpace: "nowrap",
          width: "100px"
        })}
      >
        Save
      </Button>

      <SaveViewModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};
